<div class="container">
  <h3 *ngIf="model && model.heading" data-test="gsm-abschluss_heading">
    {{ model.heading }}
  </h3>
  <button (click)="onIconClick()" mat-icon-button class="info-btn" data-test="gsm-abschluss_navigation-button">
    <mat-icon *ngIf="model.icon" class="info-icon" data-test="gsm-abschluss_icon">{{ model.icon }}</mat-icon>
  </button>
</div>

<p [innerHTML]="content"></p>

<div *ngIf="model.additional?.hasInitialPremium">
  <h3>Weisen Sie den Kunden bitte darauf hin, dass die Erstprämie noch nicht bezahlt wurde.</h3>
</div>

<p
  *ngIf="model.additional?.paperProcessOverride && model.additional?.isKonnexBlockedByPaperProcess"
  data-test="gsm-abschluss_paper-process"
>
  Aufgrund der „Originalschadenmeldung“, ist es nicht möglich einen weiteren Schaden in der Konnexsparte zu melden -
  bitte erstellen Sie
  eine neue Schadenmeldung.
</p>
<div
  *ngIf="model.options?.length && !model.additional?.paperProcessOverride && !model.additional?.isKonnexBlockedByPaperProcess"
  data-test="gsm-abschluss_konnex-container"
>
  <h3>Möchten Sie einen weiteren Schaden in einer Konnexsparte melden?</h3>
  <mat-checkbox [disabled]="model.disabled" (click)="onCheckboxClick()" data-test="gsm-abschluss_konnex-checkbox"
  >Ja, ich möchte einen weiteren Schaden zu diesem Kunden in einer Konnexsparte melden.
  </mat-checkbox>
  <mat-form-field *ngIf="checked" data-test="gsm-abschluss_konnex-select">
    <mat-label>Konnexsparte wählen</mat-label>
    <mat-select
      [disabled]="model.disabled"
      [(ngModel)]="model.value"
      (ngModelChange)="onChange()"
      data-test="gsm-abschluss_konnex-selectfield"
    >
      <mat-option *ngFor="let option of model.options" [value]="option.value">
        {{ option.label }} - {{ option.value && option.value.polizzeNummer | formatNumber: 'polizze' }}
      </mat-option
      >
    </mat-select>
  </mat-form-field>
</div>
